import type { ConversationClient } from "@/api/agent-conversation";
import type { ConversationAdapter } from "@/components/agents/conversation/types";

/**
 * O adaptador da conversa de um run, montado sobre o cliente do nó (spec 2026-10-12,
 * §6.7). Cada chamada devolve um objeto novo: quem desenha o painel o memoriza por
 * `projectId` e `runId`, porque o hook da conversa religa o stream quando o adaptador
 * muda.
 */
export function conversationAdapter(
  client: ConversationClient,
  projectId: string,
  runId: string,
): ConversationAdapter {
  return {
    projectId,
    runId,
    fetchView: (afterSeq) => client.fetchView(projectId, runId, afterSeq),
    openStream: (afterSeq, handlers) => client.openStream(projectId, runId, afterSeq, handlers),
    sendMessage: (body) => client.sendMessage(projectId, runId, body),
    interrupt: () => client.interrupt(projectId, runId),
    end: () => client.end(projectId, runId),
  };
}
